module.exports = __webpack_public_path__ + "img/Mozambique.1f96714c.svg";